import React from 'react';

const Footer = () => {
    return (
        <div className="container bg-light mt-3">
            <p className="text-center">This app is developed by A.S.M.Hasan Sarker</p>
            <p className="text-center">&copy; 2021 All Rights Reserved</p>
        </div>
    );
};

export default Footer;